import * as Yup from 'yup';
import { datetimeFromUTC } from 'utils/dayjs';

const dateRegexp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

const validationSchema =
    Yup.object().shape({
        customerName: Yup.string().when('customerFound', {
            is: false,
            then: fieldSchema => fieldSchema
                .required('Заполните поле')
        }),
        customerSurname: Yup.string().when('customerFound', {
            is: false,
            then: fieldSchema => fieldSchema
                .required('Заполните поле')
        }),
        customerEmail: Yup.string().when('customerFound', {
            is: false,
            then: fieldSchema => fieldSchema
                .email('Неверный формат email')
                .required('Заполните поле')
        }),
        customerBirthday: Yup.string().when('customerFound', {
            is: false,
            then: fieldSchema => fieldSchema
                .nullable()
                .required('Заполните поле')
                .test('customerBirthday', 'Неверный формат даты', function (value) {
                    if (!value) return false;
                    return dateRegexp.test(datetimeFromUTC(value, true).date)
                }),
        }),
        customerSkype: Yup.string().when(['customerFound', 'workingOffline'], {
            is: (customerFound, workingOffline) => !customerFound && !workingOffline,
            then: fieldSchema => fieldSchema.required('Заполните поле')
        }),
        acceptConditions: Yup.boolean()
            .required()
            .oneOf([true]),
        acceptCancelRules: Yup.boolean()
            .required()
            .oneOf([true]),
        acceptMoscowTime: Yup.boolean()
            .required()
            .oneOf([true])
    });

export default validationSchema;
